/**
 * GovernanceIcon - Ícone de escudo com relógio
 * @module components/icons/GovernanceIcon
 *
 * US-020: Redesign da Página Assessment Selection
 */

export interface IconProps {
  className?: string;
}

export function GovernanceIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      data-testid="governance-icon"
      aria-hidden="true"
    >
      <path
        d="M12 2L3 7V10C3 16.55 6.84 22.74 12 24C17.16 22.74 21 16.55 21 10V7L12 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V12L15 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
